import { bootstrap } from './bootstrap'
//import {EVENTS} from './config/'

//window.addEventListener(EVENTS.WEB_COMPONENT_PROJECTS_LOADED, () => {
//    console.log('WEB_COMPONENT_PROJECTS_LOADED event triggered');
//});
//
//window.addEventListener(EVENTS.WEB_COMPONENT_FIRST_COMPONENT_DISPLAYED, () => {
//    console.log('WEB_COMPONENT_FIRST_COMPONENT_DISPLAYED event triggered');
//});
//
//window.addEventListener(EVENTS.WEB_COMPONENT_ANCHOR_LOADED, (event) => {
//    console.log('WEB_COMPONENT_ANCHOR_LOADED event triggered with uuid:', event.detail.uuid);
//});

bootstrap()
void window.dwc.load(true)
